import { relativeTime } from "@/shared/lib/relative-time";

/**
 * Format a stock sync timestamp for display as `DD/MM/YYYY HH:mm`.
 *
 * The value is reformatted textually rather than parsed through `Date` so the
 * displayed time matches exactly what the backend recorded (no implicit timezone
 * shift) and the output is deterministic in tests. Missing or unparseable values
 * render as an em dash.
 */
export function formatSyncTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const match = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(iso);
  if (!match) return "—";
  const [, year, month, day, hour, minute] = match;
  return `${day}/${month}/${year} ${hour}:${minute}`;
}

/** Localized "5 minutes ago" for an ISO timestamp, relative to now. */
export const relativeSyncTime = relativeTime;
